module.exports = __webpack_public_path__ + "static/media/2DGACM1.c61b89f2.jpg";